import React, { useEffect } from "react";
import { GetLoggedInUserQueryResult } from "../schema/generated/schema";

export enum TrackingEvent {
  VIEW_3D_BUTTON_CLICKED = "Marketplace Frontend View 3D Button Clicked",
  LINE_ITEM_THUMBNAIL_CLICKED = "Marketplace Frontend Line Item Thumbnail Clicked",
}

function analyticsPresent() {
  if (typeof analytics === "undefined") {
    console.warn("Analytics not present on page");
    return false;
  }
  return true;
}

export function trackUser(userData: GetLoggedInUserQueryResult) {
  if (analyticsPresent() && userData?.me) {
    const {
      me: { id, firstName, lastName, emailAddress },
      partner,
    } = userData;

    analytics.identify(id, {
      username: `${firstName} ${lastName}`,
      email: emailAddress,
      partnerId: partner?.id,
    });
  }
}

export function trackClick(
  event: TrackingEvent,
  properties?: Record<string, string>
) {
  if (analyticsPresent()) {
    analytics.track(event, properties);
  }
}

export function TrackPage({
  pageName,
  children,
}: {
  pageName: string;
  children: React.ReactNode;
}) {
  useEffect(() => {
    window?.analytics?.page(pageName);
  }, []);

  return <>{children}</>;
}

export function TrackComponentLoaded({
  componentName,
  children,
}: {
  componentName: string;
  children: React.ReactNode;
}) {
  useEffect(() => {
    window?.analytics?.track(`${componentName} Component Loaded`);
  }, []);

  return <>{children}</>;
}
